import Enum from "../../../../../../enums/Enum";

const VaccinationHistoryEnum = new Enum({
    UP_TO_DATE: {name: "Up to Date"},
    UNSURE: {name: "Unsure"},
    OTHER: {name: "Other"}
});

export default VaccinationHistoryEnum;